// extracted by mini-css-extract-plugin
export default {"stampDutyPage":"StampDutyPage_stampDutyPage__OWbS0","specialH2":"StampDutyPage_specialH2__uBS7d"};